import { useDailyEvent, useMeetingState } from '@daily-co/daily-react'
import { useState } from 'react'
import { useDailyVisitInfo } from './useDailyVisitInfo'

export function useRoomIsLoading() {
  const meetingState = useMeetingState()
  const dailyVisitInfo = useDailyVisitInfo()
  const [dialoutConnected, setDialoutConnected] = useState(false)

  useDailyEvent('dialout-connected', () => {
    setDialoutConnected(true)
  })

  useDailyEvent('dialout-stopped', () => {
    setDialoutConnected(false)
  })

  const baseLoading = ['loading', 'new', 'joining-meeting'].some((x) => x === meetingState)
  const waitingForDialout = dailyVisitInfo?.isPhoneCall && meetingState === 'joined-meeting' && !dialoutConnected

  const roomIsLoading = baseLoading || !!waitingForDialout
  return { roomIsLoading }
}
